import React from "react";
import { TYPE_PC, TYPE_SP } from "./defines";

export const banner_static = (type) => {
  if (type == TYPE_SP) {
    return (
      <div className="banner_static">
        <div className="banner">
          <img src="resource/img/banner_1000_sp.jpg?20211220" alt="WEBからの申し込みで￥1,000割引！！" />
        </div>
      </div>
    );
  } else if (type === TYPE_PC) {
    return (
      <div className="banner_static">
        <div className="banner">
          <img src="resource/img/banner_1000_pc.jpg?20211220" alt="WEBからの申し込みで￥1,000割引！！" />
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./common/banner_static.jsx